import AccountsPlans from "../components/AccountPlans/AccountsPlans";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";
import PricingModal from "../components/PricingModal/PricingModal";
import { useState } from "react";
import { useParams } from "react-router-dom";

const Plans = () => {
  const [modalShow, setModalShow] = useState<boolean>(true);
  const { id } = useParams();

  return (
    <div className="plans">
      <AccountsPlans />
      {id && (
        <PricingModal
          show={modalShow}
          message={id}
          onHide={() => setModalShow(false)}
        />
      )}
    </div>
  );
};

export default Plans;
